/* unplugin-vue-components disabled */import script from "./FeedbackView.vue?vue&type=script&lang=tsx&setup=true"
export * from "./FeedbackView.vue?vue&type=script&lang=tsx&setup=true"

import "./FeedbackView.vue?vue&type=style&index=0&id=d44038d0&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d44038d0"]])

export default __exports__